import React from "react";
import { GlobalTextField } from "../../../../../global/forms/GlobalFormFields";
import GlobalBadge from "../../../../../global/GlobalBadge";
import { formatDateCell, isTruthy } from "../membershipRenewCommon";

export default function MembershipRenewHistorySection({
  sectionRef,
  historySearch,
  onHistorySearchChange,
  historyRows,
  historyLoading,
}) {
  return (
    <section ref={sectionRef} className="user-builder-panel" style={{ marginTop: "1rem" }}>
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Renewal History</h3>
        <p className="user-builder-panel__hint">Search and view past renewal records.</p>
      </div>
      <div style={{ maxWidth: "420px", marginBottom: "0.75rem" }}>
        <GlobalTextField
          label="Search by student name"
          value={historySearch}
          onChange={onHistorySearchChange}
          placeholder="Type student name"
        />
      </div>
      {!String(historySearch || "").trim() ? (
        <div className="vpart-empty vt-table-wrap">Type a student name to search renewal history.</div>
      ) : historyLoading ? (
        <p className="ub-loading">Loading renewal history...</p>
      ) : historyRows.length === 0 ? (
        <div className="vpart-empty vt-table-wrap">No renewal history found.</div>
      ) : (
        <div className="vt-table-wrap">
          <table className="vt-table" aria-label="Renewal history table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Membership</th>
                <th>Start date</th>
                <th>End date</th>
                <th>Payment verified</th>
                <th>Renewal verified</th>
              </tr>
            </thead>
            <tbody>
              {historyRows.map((row) => (
                <tr key={row.renewal_id}>
                  <td>{row.student_name || "—"}</td>
                  <td>{row.membership_name || "—"}</td>
                  <td>{formatDateCell(row.start_date)}</td>
                  <td>{formatDateCell(row.end_date)}</td>
                  <td>
                    <GlobalBadge
                      active={isTruthy(row.payment_verified)}
                      activeText="Verified"
                      inactiveText="Not verified"
                    />
                  </td>
                  <td>
                    <GlobalBadge
                      active={isTruthy(row.renewal_verified)}
                      activeText="Verified"
                      inactiveText="Not verified"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
